{
  "page": {
    "title": "Sales Operations",
    "subtitle": "GMV, production and forecast analytics"
  },
  "tabs": {
    "dashboard": "Dashboard",
    "comparison": "Product Comparison",
    "forecast": "Forecast"
  },
  "range": {
    "label": "Month range",
    "trigger": "Select month range",
    "from": "From",
    "to": "To",
    "apply": "Apply",
    "cancel": "Cancel",
    "invalid": "\"From\" must be on or before \"To\"",
    "monthAria": "Select month"
  },
  "freshness": {
    "ready": "Data as of {{when}}",
    "stale": "Data may be outdated — last computed {{when}}",
    "bootstrapping": "Building analytics for the first time. Numbers will appear shortly.",
    "recomputing": "Recomputing analytics — data as of {{when}}",
    "unknown": "Freshness unknown"
  },
  "cardState": {
    "loading": "Loading…",
    "bootstrapping": "This report is still being prepared.",
    "empty": "No data in the selected range.",
    "insufficient": "Not enough data to compute a reliable value.",
    "error": "Could not load this section.",
    "retry": "Retry"
  },
  "sectionNav": {
    "label": "Jump to section",
    "tiles": "Overview",
    "weekly": "Weekly GMV",
    "channel": "Channel mix",
    "status": "Status mix",
    "pivot": "Status pivot",
    "products": "Top products",
    "refund": "Refund rate",
    "variants": "Top variants",
    "factories": "Factories",
    "production": "Production",
    "regions": "Regions",
    "dataQuality": "Data quality"
  },
  "dashboard": {
    "title": "Operations dashboard",
    "statTiles": {
      "platformGmv": "Platform GMV",
      "orders": "Orders",
      "items": "Items",
      "avgOrderValue": "Avg order value",
      "gmvTooltipAria": "About platform GMV",
      "gmvFormulaTitle": "Platform GMV",
      "gmvFormulaBody": "Sum of paid order totals across all channels in the selected range.",
      "gmvDiffersNote": "Differs from the GMV Report's attributed GMV."
    },
    "weeklyGmv": {
      "title": "Weekly GMV",
      "subtitle": "{{current}} vs {{previous}}",
      "xAxisLabel": "ISO week",
      "weekTick": "W{{week}}",
      "legendCurrent": "{{year}}",
      "legendPrevious": "{{year}}",
      "legendPartial": "Current week (partial)",
      "priorYearEmptyNote": "No {{year}} data to compare."
    }
  },
  "channel": {
    "normal": "Normal",
    "sample": "Sample",
    "tiktok": "TikTok"
  },
  "status": {
    "Open": "Open",
    "Paid": "Paid",
    "Unpaid": "Unpaid",
    "Pending": "Pending",
    "Processing": "Processing",
    "InProduction": "In production",
    "Shipped": "Shipped",
    "Delivered": "Delivered",
    "Completed": "Completed",
    "Cancelled": "Cancelled",
    "Refunded": "Refunded",
    "PartiallyRefunded": "Partially refunded",
    "OnHold": "On hold",
    "Failed": "Failed"
  },
  "channelMix": {
    "title": "GMV by channel",
    "sharePct": "{{pct}}%",
    "orders": "{{count}} orders",
    "empty": "No channel data in the selected range.",
    "loadingAria": "Loading channel mix",
    "figureAria": "GMV share by channel"
  },
  "statusMix": {
    "orderTitle": "GMV by order status",
    "paymentTitle": "GMV by payment status",
    "orders": "{{count}} orders",
    "empty": "No status data in the selected range.",
    "loadingAria": "Loading status mix",
    "orderFigureAria": "GMV by order status",
    "paymentFigureAria": "GMV by payment status"
  },
  "statusPivot": {
    "title": "Order status × payment status",
    "caption": "GMV by order status and payment status",
    "rowHeader": "Order status",
    "empty": "No pivot data in the selected range.",
    "loadingAria": "Loading status pivot",
    "cellTitle": "{{order}} · {{payment}}: {{gmv}} ({{count}} orders)"
  },
  "topProducts": {
    "title": "Top products by revenue",
    "sortBy": "Sort by {{column}}",
    "columns": {
      "product": "Product",
      "revenue": "Revenue",
      "qty": "Qty",
      "orders": "Orders"
    }
  },
  "factories": {
    "title": "Factories",
    "unmapped": "Country unmapped",
    "expandRow": "Show breakdown for {{vendor}}",
    "collapseRow": "Hide breakdown for {{vendor}}",
    "columns": {
      "vendor": "Vendor",
      "country": "Country",
      "gmv": "GMV",
      "products": "Products",
      "orders": "Orders",
      "medianProduction": "Median production"
    },
    "drilldown": {
      "empty": "No products for this vendor in the selected range.",
      "insufficient": "Insufficient",
      "hours": "{{value}}h",
      "columns": {
        "product": "Product",
        "orders": "Orders",
        "qty": "Qty",
        "medianProduction": "Median production"
      }
    }
  },
  "production": {
    "title": "Production performance",
    "colProduct": "Product",
    "colOrders": "Orders",
    "colApproval": "Median approval",
    "colProduction": "Median production",
    "colItemsPerOrder": "Items / order",
    "hours": "{{value}}h",
    "insufficient": "Insufficient ({{n}})",
    "insufficientTooltip": "Fewer than 5 samples — median suppressed."
  },
  "refund": {
    "title": "Refund / resend rate",
    "colProduct": "Product",
    "colMonth": "Month",
    "colRate": "Rate",
    "colAmount": "Refund amount",
    "monthOverrideLabel": "Month",
    "monthAll": "All months",
    "flaggedSr": "Above the {{threshold}} threshold"
  },
  "regions": {
    "title": "Shipping regions",
    "byCountry": "By country",
    "byState": "By state",
    "legendGmv": "GMV",
    "legendOrders": "Orders",
    "tooltipGmv": "GMV:",
    "tooltipOrders": "{{count}} orders"
  },
  "topVariants": {
    "title": "Top variants",
    "productLabel": "Select product",
    "productPlaceholder": "Choose a product",
    "axisRevenue": "Revenue",
    "noVariants": "No variants for this product."
  },
  "pagination": {
    "summary": "Page {{page}} of {{totalPages}} · {{total}} total",
    "prev": "Previous",
    "next": "Next"
  },
  "state": {
    "refreshing": "Refreshing…"
  },
  "actions": {
    "retry": "Retry"
  },
  "comparison": {
    "placeholder": "Product comparison will be available soon.",
    "periodA": "Period A",
    "periodB": "Period B",
    "periodAAria": "Select period A",
    "periodBAria": "Select period B",
    "kindAria": "Period type",
    "versus": "vs",
    "quarterLabel": "Q{{quarter}} {{year}}",
    "kind": {
      "month": "Month",
      "quarter": "Quarter"
    },
    "matched": {
      "title": "Matched products",
      "subtitle": "Products present in both periods, with per-metric change.",
      "columns": {
        "product": "Product",
        "ordersA": "Orders {{period}}",
        "ordersB": "Orders {{period}}",
        "deltaOrders": "Δ Orders",
        "itemsA": "Items {{period}}",
        "itemsB": "Items {{period}}",
        "deltaItems": "Δ Items",
        "refundA": "Refund {{period}}",
        "refundB": "Refund {{period}}",
        "deltaRefund": "Δ Refund"
      },
      "deltaUp": "increased",
      "deltaDown": "decreased",
      "deltaFlat": "unchanged"
    },
    "changed": {
      "title": "New & dropped products",
      "subtitle": "Products present in only one period.",
      "newIn": "New in {{period}}",
      "droppedAfter": "Dropped after {{period}}",
      "columns": {
        "product": "Product",
        "status": "Status",
        "orders": "Orders",
        "items": "Items",
        "refund": "Refund rate"
      }
    },
    "bySupplier": {
      "title": "By supplier",
      "subtitle": "New and dropped products per supplier.",
      "none": "—",
      "columns": {
        "supplier": "Supplier",
        "newCount": "New",
        "droppedCount": "Dropped",
        "newProducts": "New products",
        "droppedProducts": "Dropped products"
      }
    }
  },
  "forecast": {
    "placeholder": "Forecast will be available soon.",
    "title": "Forecast {{targetYear}}",
    "subtitle": "Seasonality bands, cohort projection and H2 guidance vs {{prevYear}}.",
    "degradeBanner": "Not enough prior-year history for a seasonality fan chart. Showing the cohort-based projection only.",
    "fanChart": {
      "title": "Seasonality forecast",
      "subtitle": "Dampened bands ({{targetYear}}) vs actuals",
      "actualLegend": "Actual",
      "band100": "100% seasonality",
      "band50": "50% dampened",
      "band25": "25% dampened",
      "empty": "No seasonality data available.",
      "xAxisLabel": "Month"
    },
    "cohort": {
      "title": "Cohort channel projection",
      "subtitle": "Projected H2 GMV: {{value}}",
      "nonTiktok": "Non-TikTok",
      "tiktok": "TikTok",
      "total": "Total",
      "empty": "No cohort projection available.",
      "drivers": {
        "title": "Projection drivers",
        "activeSellers": "Active sellers",
        "gmvPerSeller": "GMV per seller"
      }
    },
    "guidance": {
      "title": "Recommended variant",
      "recommended": "Recommended: {{variant}}",
      "none": "No single variant is recommended — review the cross-checks below.",
      "reasonsTitle": "Cross-checks",
      "variant": {
        "100pct": "100% seasonality",
        "50pct": "50% dampened",
        "25pct": "25% dampened"
      }
    },
    "halfYear": {
      "title": "Half-year summary",
      "subtitle": "Prior-year actual, current H1 actual, projected H2 and full year.",
      "empty": "No half-year summary available.",
      "period": "Period",
      "actualBadge": "Actual",
      "projectedBadge": "Projected",
      "columns": {
        "nonTiktok": "Non-TikTok",
        "tiktok": "TikTok",
        "total": "Total"
      }
    },
    "assumptionsTitle": "Assumptions"
  },
  "export": {
    "button": "Export",
    "dialogTitle": "Export report",
    "dialogDesc": "Choose a file format. The download will start when the file is ready.",
    "formatLabel": "File format",
    "format": {
      "csv": "CSV",
      "xlsx": "Excel (XLSX)"
    },
    "cancel": "Cancel",
    "confirm": "Export",
    "working": "Preparing…",
    "progress": "Preparing your file… {{progress}}%",
    "started": "Export started.",
    "ready": "Your file is ready. Download starting.",
    "failed": "The export failed. Please try again.",
    "expired": "This export has expired. Please export again.",
    "failedTitle": "Export failed",
    "pollFailedTitle": "Could not check export status"
  },
  "recompute": {
    "button": "Recompute",
    "working": "Recomputing…",
    "confirmTitle": "Recompute analytics?",
    "confirmDesc": "This rebuilds all analytics from scratch and may take a few minutes. Existing data stays visible until the new results are ready.",
    "confirm": "Recompute",
    "cancel": "Cancel",
    "started": "Recompute started.",
    "alreadyRunning": "A recompute is already running",
    "alreadyRunningDesc": "A recompute is already in progress. Please wait for it to finish.",
    "failedTitle": "Recompute failed"
  },
  "errors": {
    "generic": "Something went wrong.",
    "validation": "Some filters are invalid. Please check and try again.",
    "unauthenticated": "Your session has expired. Please sign in again.",
    "forbidden": "You do not have permission to view this report.",
    "invalidRange": "The selected date range is invalid.",
    "network": "Network error. Please try again."
  }
}
